@if (pendingChanges?.length || subFormCount) {
    <wdx-alert
        data-cy="pending-changes-alert"
        themeColor="warning"
        [allowFlex]="false"
    >
        <div class="d-flex justify-content-between">
            <div class="d-flex align-items-start">
                <wdx-icon
                    class="me-2"
                    data-cy="pending-changes-icon"
                    [icon]="ICON_TRIANGLE_EXCLAMATION"
                ></wdx-icon>
                <div>
                    @let count =
                        (pendingChanges?.length || 0) + (subFormCount || 0);
                    <p
                        class="mb-1"
                        data-cy="pending-changes-message"
                        [textContent]="
                            count
                                | i18nPlural: PENDING_CHANGES_MAPPING
                                | translateTokenisedString
                                    : {
                                          count: '' + count,
                                      }
                        "
                    ></p>
                    @for (
                        pendingChange of pendingChanges;
                        track $index;
                        let i = $index
                        ) {
                        <div
                            [attr.data-cy]="'pending-change-' + i"
                            [textContent]="
                                    PENDING_TEXT
                                        | replace
                                            : [
                                                  {
                                                      value:
                                                          pendingChange?.name ??
                                                              pendingChange?.field ??
                                                              ''
                                                          | translateTokenisedString,
                                                      target: '{field}',
                                                  },
                                                  {
                                                      value: pendingChange?.originalDisplayValue!,
                                                      target: '{original}',
                                                  },
                                                  {
                                                      value: pendingChange?.targetDisplayValue!,
                                                      target: '{target}',
                                                  },
                                              ]
                                "
                        ></div>
                    }
                    @for (
                        subForm of pendingChangesSubForm | keyvalue;
                        track $index;
                        let i = $index;
                        let last = $last
                        ) {
                        <div [attr.data-cy]="'pending-change-sub-form-' + i">
                            {{
                                subForm.value.label | translateTokenisedString
                            }}:
                            @if (subForm.value.updating) {
                                @let updatingCount =
                                    '' + subForm.value.updating;
                                <span class="me-2">
                                        <span
                                            [innerHTML]="
                                                subForm.value?.updating
                                                    | i18nPlural
                                                        : PENDING_CHANGES_SUB_FORM_UPDATE
                                                    | translateTokenisedString
                                                        : {
                                                              count: updatingCount,
                                                          }
                                            "
                                        ></span>
                                    </span>
                            }
                            @if (subForm.value.adding) {
                                @let addingCount = '' + subForm.value?.adding;
                                <span class="me-2">
                                        <span
                                            [innerHTML]="
                                                subForm.value?.adding
                                                    | i18nPlural
                                                        : PENDING_CHANGES_SUB_FORM_ADD
                                                    | translateTokenisedString
                                                        : {
                                                              count: addingCount,
                                                          }
                                            "
                                        >
                                        </span>
                                    </span>
                            }
                            @if (subForm.value.deleting) {
                                @let deletingCount =
                                    '' + subForm.value.deleting;
                                <span class="me-2">
                                        <span
                                            [innerHTML]="
                                                subForm.value?.deleting
                                                    | i18nPlural
                                                        : PENDING_CHANGES_SUB_FORM_DELETE
                                                    | translateTokenisedString
                                                        : {
                                                              count: deletingCount,
                                                          }
                                            "
                                        >
                                        </span>
                                    </span>
                            }
                        </div>
                    }
                </div>
            </div>
            @if (showButton) {
                <div class="align-self-center">
                    <button
                        wdxButton
                        data-cy="pending-changes-button"
                        (click)="onClick()"
                    >
                        {{ CHANGE_SUMMARY_BTN | translateTokenisedString }}
                    </button>
                </div>
            }
        </div>
    </wdx-alert>
}
